import gql from 'graphql-tag';

export default gql`
  fragment floorPlanFields on FloorPlan {
    id
    imageUrl
    width
    height
  }
`;
